import styled from 'styled-components';

import type {
  MenuComponent,
} from '../types';

export const Menu = styled.div({
  boxSizing: 'border-box',
  position: 'absolute',
  top: '100%',
  width: '100%',
  zIndex: 1,
  marginTop: '4px',
  maxHeight: '200px',
  overflowY: 'auto',
  borderRadius: '4px',
  backgroundColor: '#fff',
  border: '1px solid #d9e1e8',
  boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)',
}) as unknown as MenuComponent;
